export const SET_TRADENAME = (state, value) => {
  state.tradeName = value
}

export const SET_NAME = (state, value) => {
  state.name = value
}

export const SET_DOCUMENT = (state, value) => {
  state.document = value
}

export const SET_SOURCE = (state, value) => {
  state.source = value
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}

export const SET_DEPARTMENT = (state, value) => {
  state.department = value
}

export const SET_MANAGERBODYCODE = (state, value) => {
  state.managerbodyCode = value
}

export const SET_RECEIVERCODE = (state, value) => {
  state.receiverCode = value
}
